module.exports = __webpack_public_path__ + "img/cases-brand-suning-3.2fa9ae1c.jpg";